mcWeb.checkout = new function () {

  this.events = {
      onShowSendOrder: "mcWeb.checkout.onShowSendOrder"      
  };

	var $ = jQuery;
	var self = this;
	self.service = new WebApiService("Checkout");
	self.langService = new LanguageService();
  
	self.cartName = null;
    self.cartGuid = null;
		
    $(function () {

        self.isCheckoutPage = ($("#checkout").length > 0) ? true : false;

        if (!self.isCheckoutPage)
            return;

		var returnCode = self.getParameterByName("returnCode");
		self.showErrorMessageFromReturnCode(returnCode);

		var btnOrderEl = $("#McPaymentAddOrderbottom");
		var priceEl = $("#checkout-amount");
		var salesConditionsEl = $("#mcweb-salesconditions-sales-conditions");

		PubSub.subscribe(mcWeb.checkout.events.onShowSendOrder, function (message, status) {

            if (status === null)
                return;

            var registration = mcWeb.customerRegistration.instances["checkout-registration"];
            if (registration !== null) {
                //Blocked or not active customer
                if (registration.registrationVM.blockedCustomer()) {
                        status.showBtn = false;
                        status.disabledBtn = true;
                    $(".sales-conditions").hide();
                }
            }


            if (status.showBtn !== null || status.disabledBtn !== null) {

                if (status.disabledBtn !== null)
                {
                    if (status.disabledBtn === true) {
                        btnOrderEl.removeClass("btn-primary");
                        btnOrderEl.addClass("btn-default disabled");
                    } else {
                        btnOrderEl.removeClass("btn-default disabled");
                        btnOrderEl.addClass("btn-primary");
                    }
                }

                if (status.showBtn !== null) {

                    if (status.showBtn === true) {
                        btnOrderEl.show();
                    } else {
                        btnOrderEl.hide();
                    }
                }
            }//showBtn or disabledBtn

            if (status.showPrice !== null) {
                if (status.showPrice === true) {
                    priceEl.show();
                } else {
                    priceEl.hide();
                }
            }

            if (status.showSalesConditions !== null) {

                if (status.showSalesConditions === true) {
                    salesConditionsEl.show();
                } else {		      
                    salesConditionsEl.hide();
                }
            }

        });

	});


    self.findElement = function (payment, element) {
        return $("div[id=" + payment.selectedPayment() + "]").find("input[id*='" + element + "']");
    };

    self.findClass = function (payment, cssClass) {
        return $("div[id=" + payment.selectedPayment() + "]").find("input[class*='" + cssClass + "']");
    };
	
	self.validatePayment = function (payment) {
		var paymentId = payment.selectedPayment();
		var element;
		var validate = false;
		var isValid = false;
		var resName = "";

		if (paymentId === 96 || paymentId === 97) {	//Klarna 
			validate = true;
            if (payment.CustomerType() === "private" || payment.CustomerType() === "privatkunde") {
                element = self.findElement(payment, "fodselsnummer");
				isValid = payment.isFodselsnummerValid($("#fodselsnummer"), true);
				resName = "FodselsnummerError";
			} else {
                element = self.findElement(payment, "orgnr");
				isValid = payment.isOrgnrValid($("#orgnr"), true);
				resName = "OrgnummerError";
			}
        } else if (paymentId === 94 || paymentId === 107) { //Gothia private
			element = self.findElement(payment, "birth_ssn");
			validate = true;
			isValid = payment.isFodselsnummerValid($("#birth_ssn"), false);
			resName = "FodselsnummerError";
        } else if (paymentId === 95) { //Gothia business
			element = self.findElement(payment, "orgnr_ssn");
			validate = true;
			isValid = payment.isOrgnrValid($("#orgnr_ssn"), false);
			resName = "OrgnummerError";
        } else if (paymentId === 112 || paymentId === 115 || paymentId === 168) { //Santander
			validate = true;
			var paymentViewSantander = mcWeb.payments.instances["payment-view"];
            var validSantander = paymentViewSantander.validateSantander(payment);

			isValid = validSantander.IsValid;
			resName = validSantander.ResName;
			element = validSantander.Element;
		} else if (paymentId === 87 || paymentId === 128) {
			validate = true;
			var paymentViewSvea = mcWeb.payments.instances["payment-view"];
            var validSveaWebPay = paymentViewSvea.validateSveaWebPay(payment);

			isValid = validSveaWebPay.IsValid;
			resName = validSveaWebPay.ResName;
			element = validSveaWebPay.Element;
		} else if (payment.ShowOrgnrSsn()) {
			validate = true;
			var fieldType = payment.ShowOrgnrSsnField();
			switch (fieldType) {
			case 1:
                element = self.findClass(payment, "genericOrgnr");
                isValid = payment.isOrgnrValid($(".genericOrgnr"), false);
                resName = "OrgnummerError";
                break;
			case 2:
                element = self.findClass(payment, "genericSsn");
                isValid = payment.isFodselsnummerValid($(".genericSsn"), false);
                resName = "FodselsnummerError";
                break;
			case 3:
                element = self.findClass(payment, "genericBirthdate");
                isValid = payment.isBirthdateValid($(".genericBirthdate"), false);
                resName = "FodselsdatoError";
                break;
			default:
                isValid = false;
                resName = "MissingFields";
                break;
			}
		} else {
            isValid = true;
		}

		if (validate) {
			if (!isValid) {
				var errorText = mcWeb.validation.getErrorMessage("VALIDATION," + resName);
				errorText.done(function (result) {
					mcWeb.validation.qTipActionShow(element, result, false);
					mcWeb.validation.addErrorClass(element);
				});
			} else {
				if (element) {
					mcWeb.validation.setValidCss(element);
				}
			}
		}

		return isValid;
	};
    
    self.disableOrderButton = function() {
        $("#McPaymentAddOrderbottom").attr("disabled", "disabled");
    };

    self.enableOrderButton = function() {
        $("#McPaymentAddOrderbottom").removeAttr("disabled");
    };
    
    self.insertOrder = function (conditionsVM) {
        self.disableOrderButton();
        self.conditionsVM = conditionsVM;
		var btnSendOrder = $("#McPaymentAddOrderbottom.btn-default.disable");
		if (btnSendOrder.length > 0) {
			self.showErrorMessage($("#missing-info").html());
            self.enableOrderButton();
			return;
		}

        if ($(".hide-zipcode").length === 0) {
            var zipCode = $("#carrier-zipcode");
            if (zipCode[0] !== undefined) {
                if (zipCode.val().length < 1) {
                    zipCode.focus();
                    self.enableOrderButton();
                    return;
                }
            }
        }

		$("#insert-order-alert").hide();
		var registration = mcWeb.customerRegistration.instances["checkout-registration"];
        var payment = mcWeb.payments.instances["payment-view"];

        if (typeof registration.registrationVM.epost() === 'string')
            registration.registrationVM.epost(registration.registrationVM.epost().toLowerCase());
		
		var paymentValidationResult = self.validatePayment(payment);
		self.showWaitTemplate();
        if (!registration.validateCustomerSelectionType()) {
            self.enableOrderButton();
            return;
        }

        registration.validate().then(function (validationResult ) {

            if (!validationResult.success || !paymentValidationResult) {
                if (!paymentValidationResult) {
                    // paymentError
                }
                else if (registration.requireLogin()) {
                    //window.location.hash = "#login"; // Todo: Endre til en event via PubSub
                    self.showErrorMessage($(".text-email-blocked").html());
                } else if (validationResult.invalidElements.length > 0) {
                    self.scrollToFirstInvalidElement(validationResult.invalidElements[0].elem);
                } else {
                    if(validationResult.message !== null && validationResult.message.length > 0)
                        self.showErrorMessage(validationResult.message);
                }
                self.enableOrderButton();
				return;
			}

			if (!self.salesConditionsAccepted()) {
				self.showErrorMessage($(".sales-cond-warning").html());
                self.enableOrderButton();
				return;
			}

            // Sjekker om SkiAssembly er aktivert og om det er produkter i handlevognen som mangler info
            self.service.GetAction("ShowSkiAssembly", null).done(function (result) {
                if (result.length > 0) {
                    self.enableOrderButton();

                    if (result === "mcWeb.SkiAssembly")
                        getLibrary("skiassembly").then(() => { 
                            mcWeb.SkiAssembly.load(true);
                        });
                    else if (result === "mcWeb.SkiAttributeAssembly")
                        getLibrary("skiattributeassembly").then(() => {
                            mcWeb.SkiAttributeAssembly.load();
                        });
                    else if (result === "mcWeb.cart.events.onPopupForProductAssembly") {
                        PubSub.publish(result.MessageToPublish, result.MessageToPublishData);
                    }
                    else {
                        console.log(result)
                        alert("Error - Cant show ski assembly");
                    }
                    return;
                }

                // Viser "vennligst vent"-melding
                PubSub.publish(mcWeb.lightbox.events.onShowLightbox, { backdrop: "static", keyboard: false, show: true });

                var customer = registration.getJsonData(self.conditionsVM);
                var paymentData = payment.getJsonData();
                var paymentDetails;

                if (paymentData.selectedPayment === 112 || paymentData.selectedPayment === 115 || paymentData.selectedPayment === 168) {
                    var resourceName = payment.validateSantanderAddress(customer.postnr, customer.poststed, customer.adress);

                    if (resourceName !== "") {
                        self.langService.getValue("VALIDATION", resourceName).done(function (value) {
                            if (value.length > 0)
                                self.showErrorMessage(value);
                        });
                        self.enableOrderButton();
                        return;
                    }

                    paymentDetails = paymentData.santanderApplicationDetails;
                    paymentDetails.RegisteredPostCode = paymentData.paymentDetails.RegisteredPostCode;
                } else {
                    paymentDetails = paymentData.paymentDetails;
                }

                if (paymentData.paymentDetails.Birthdate !== "undefined")
                    customer.birthDate = paymentData.paymentDetails.Birthdate;

                if (customer.customerType === "undefined" && payment.CustomerType() === "privatkunde")
                    customer.customerType = "private";

                var registrationVM = mcWeb.customerRegistration.instances['checkout-registration'].registrationVM;
                if (registrationVM.deliveryWindow() !== null) {
                    var deliveryWindow = registrationVM.deliveryWindow()
                    customer.deliveryWindow = { start: deliveryWindow.start, end: deliveryWindow.end, token: deliveryWindow.token, expiresAt: deliveryWindow.expiresAt };
                    customer.porterbuddyProduct = deliveryWindow.product;
                }

                self.service.PostAction("ProcessOrder", { CustomerData: customer, PaymentDetails: paymentDetails, CartGuid: self.cartGuid, CartName: self.cartName }).done(function (result) {

                    if (result.ReturnCode === "Success") {

                        window.location = result.RedirectUrl;
                       
                    } else {
                        self.enableOrderButton();
                        PubSub.publish(mcWeb.checkout.events.onShowSendOrder, { showBtn: true, disabledBtn: false });
                        
                        if (result.ReturnCode === "ValidatePostalAddressFailed" & result.ErrorMessageSpecified) {
                            self.showErrorMessageFromReturnCode(result.ErrorMessage);
                        }
                        else if (result.ReturnCode == "UnsupportedCurrency") {
                            var selectCurrencyParam = {
                                SupportedCurrencies : result.SupportedCurrencies
                            }
                            var loginServcie = new WebApiService("Login");
                            loginServcie.PostAction("SelectAnyValidCurrency", selectCurrencyParam).done(function (changedCurrencyResult) {
                                
                                self.showErrorMessage(changedCurrencyResult.Msg);
                                $("#center-popup").on("hidden.bs.modal", function (e) {
                                    PubSub.publish(mcWeb.cart.events.onChangedCart);
                                });
                            });
                        }
                        else if (result.ErrorMessageSpecified) {
                            self.showErrorMessage(result.ErrorMessage);
                            if (result.ReturnCode === "ProductValidationFailed") {
                                $("#center-popup").on("hidden.bs.modal", function (e) {
                                    PubSub.publish(mcWeb.cart.events.onChangedCart);
                                });
                            }
                        }
                        else if (result.SecondaryErrorMessageSpecified) {
                            if (result.UseSecondaryErrorMessageAsReturnCode)
                                self.showErrorMessageFromReturnCode(result.SecondaryErrorMessage);
                            else
                                self.showErrorMessage(result.SecondaryErrorMessage);
                        }
                        else {
                            if (result.ReturnCode === "SelectedCarrierNoLongerAvailable")
                                PubSub.publish(mcWeb.cart.events.onShowShipment, { show: true });
                            //PubSub.publish(mcWeb.cartsmall.events.onChangedQuantityCartSmall, "");
                            PubSub.publish(mcWeb.shipment.events.reloadShipment, null);

                            if (result.ReturnCode === "SessionNotValid") result.ReturnCode = "CurrentSessionHasExpired";
                            self.showErrorMessageFromReturnCode(result.ReturnCode);

                            if (result.ReturnCode === "CurrentSessionHasExpired" || result.ReturnCode === "ExperianError" || result.ReturnCode === "ExperianNoCreditApproval" ||
                                result.ReturnCode === "CampaignInvalid" || result.ReturnCode === "CartArchivedOrInserted") {
                                $("#center-popup").on("hidden.bs.modal", function(e) {
                                    window.location.reload(true);
                                });
                            }
                            else if (result.ReturnCode === "CartValueAltered" || result.ReturnCode ==="GiftcardAmountNeededRefresh"  ) {
                                $("#center-popup").on("hidden.bs.modal", function(e) {
                                    PubSub.publish(mcWeb.cart.events.onChangedCart);
                                });
                            }
                        }
                    }
                });
            });
		})
		.fail(function (error) {
			$("#checkout-popup").modal("hide");
            self.enableOrderButton();
			console.log(error);
		});
	};

    self.salesConditionsAccepted = function() {
        var salesCondCheckbox = $(".checkbox-sales-cond");
        var salesconditions = $(".sales-conditions");
        salesconditions.removeClass("has-error");
        if (salesCondCheckbox.length > 0 && salesconditions.is(":visible")) {
            if (salesCondCheckbox.prop("checked")) {
                return true;
            }
        } else {
            return true;
        }

        salesconditions.addClass("has-error");
        return false;
    };

	self.showErrorMessage = function (message) {
		if (message.length > 0)
			self.showAlertErrorMessage(message);
	};

	self.showErrorMessageFromReturnCode = function (returnCode) {
		if (returnCode.length === 0)
			return;

		var unknownErrorCodes = [
			"CartIsNull", "SetCustomerDataFailed", "SetCartValuesFailed",
			"SaveCartFailed", "CommitPhoneFailed", "BrokenCartReplaced"
		];

		if (unknownErrorCodes.indexOf(returnCode) !== -1)
			returnCode = "UnknownError";

		self.langService.getValue("CheckoutReturnCodes", returnCode).done(function (value) {
            if (value.length > 0) {
                var country = self.getParameterByName("country");
                if (country) value = value.replace(/{COUNTRY}/gi, country);

                var email = self.getParameterByName("email");
                if (email) value = value.replace(/{EMAIL}/gi, email);

                self.showAlertErrorMessage(value);
            }
			else {
				self.langService.getValue("CheckoutReturnCodes", "UnknownError").done(function (value) {
					if (value.length > 0)
						self.showAlertErrorMessage(value);
					else
						self.showAlertErrorMessage("");	//TODO: Hide progressdialog
				});
			}
		});
	};

    self.showAlertErrorMessage = function(message, asHtml) {
        var msg = $("#error-message-label");
        if (asHtml === true) {
            msg.append(message);
        } else {
            msg.html(message);
        }

        self.showTemplate($("#popup-error-message").html());
        PubSub.publish(mcWeb.lightbox.events.onShowLightbox, { show: true });
    };

	self.scrollToFirstInvalidElement = function (element) {
		var animationTime = 750;
		var topOffset = 120;
		$("html, body").animate({
			scrollTop: $(element).offset().top - topOffset
		}, animationTime);
		element.focus();
    };

	self.getParameterByName = function (name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
				results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}

	self.showWaitTemplate = function () {

		var wait = $("#popup-wait");
		if (wait.length < 1)
			return;

		self.showTemplate(wait.html());
	};

	self.showTemplate = function (html) {

		var template = $("#lightbox-placeholder");
		if (template.length < 1) {
            PubSub.publish(mcWeb.checkout.events.onShowSendOrder, { showBtn: false, disabledBtn: false });
			return;
		}

		template.html(html);
	};

	PubSub.subscribe(mcWeb.cart.events.cartGuid, function (message, data) {
		if (data !== null) {
			self.cartName = data.cartName;
			self.cartGuid = data.cartGuid;
		}		
    });
};
